import type { FaireProductEntity } from "../../entity_types/product";

export const p_39rkzwtu63: FaireProductEntity = {
  token: "p_39rkzwtu63",
  type: "product",
  name: "Classy Care Men’s Grooming Kit –  (18pk), Skid",
  brandToken: "b_7e96273d",
  brandName: "Lucky Jack",
  imageUrl:
    "https://cdn.faire.com/fastly/5436bee30940277a596acf6e4340667a05554b3a870ccb6c98cbb0dff180f6fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/377f6b90d49a4d8562a4b28a86f63a4b74efb5d60638889108cef159dd967029.jpeg",
    "https://cdn.faire.com/fastly/c1474e260197cec175e8e0eefcaa113fd76f235fb953867a15ef642cd21b89fb.jpeg",
    "https://cdn.faire.com/fastly/1034c236c8a33d9fedfd4da38b7d51a6ccba756a6d3b610be37b637f12964c65.jpeg",
    "https://cdn.faire.com/fastly/a29482655dfd44023cbb9e93ea8ac25b088a70a7b157aee161606e3d8d12f316.jpeg",
    "https://cdn.faire.com/fastly/5028653e7e276f1e73cd6b320be80922caf4f396dbd8c87a0d16a51a38bee2f3.jpeg",
  ],
  priceDollars: 11,
  description:
    "A proven, giftable men’s grooming kit retailers rely on for easy add-on sales.\n\n\t•\tPerforms strongly as a Valentine’s Day gift for him and a Father’s Day gift\n\t•\tFREE countertop display skid included for fast setup and impulse placement\n\t•\tNo sizing, no trend risk — practical grooming essentials with low returns\n\nProduct Facts\n\n\t•\tBrown leather zippered pouch\n\t•\tIncludes nail clippers, angled clippers, cuticle pusher, beard scissors, file, tweezers, ear wax pick\n\t•\tIncludes 18 units + display skid",
  tags: [],
  msrpDollars: 22,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:49.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
